import {
  Component,
  input,
  output,
  computed,
  signal,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SoPremiumIconUI } from '../so-premium-icon/so-premium-icon.component';

export interface SoSectionCardItem {
  title: string;
  subtitle?: string;
  icon?: string;
  svgIcon?: string;
  borderColor?: string;
  disabled?: boolean;
  route?: string;
}

@Component({
  selector: 'so-section-card-ui',
  standalone: true,
  imports: [CommonModule, SoPremiumIconUI],
  templateUrl: './so-section-card.component.html',
  styleUrl: './so-section-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SoSectionCardUI {
  // Inputs
  title = input.required<string>();
  subtitle = input<string>('');
  icon = input<string>('');
  svgIcon = input<string>('');
  borderColor = input<string>('--so-primary');
  active = input<boolean>(false);
  disabled = input<boolean>(false);
  
  // Height configuration
  cardHeight = input<number | null>(null);
  
  // Icon configuration
  iconSize = input<number>(18);
  iconPadding = input<number>(8);
  iconBorderRadius = input<number>(10);

  // Outputs
  cardClick = output<void>();

  // Internal state
  private internalActive = signal(false);

  // Computed
  protected isActive = computed(() => this.active() || this.internalActive());

  protected effectiveBorderColor = computed(() => {
    const color = this.borderColor();
    if (color.startsWith('--')) {
      return `var(${color})`;
    }
    if (color.startsWith('#') || color.startsWith('rgb')) {
      return color;
    }
    return `var(--${color})`;
  });

  // Methods
  handleClick(): void {
    if (!this.disabled()) {
      this.cardClick.emit();
    }
  }
}
